module.exports = __webpack_public_path__ + "2023124:cb48231cec1aa2d91890/img/sol-logo-c-word.843346c.png";